module.exports = __webpack_public_path__ + "static/media/caramida-aparenta-klinker-Kathedral.339d1ca9.jpg";